<!--历史曲线 historyCurve-->
<template>
  <div class="historyCurve">
    <div class="con" style="background-color: #eee;">
      <div class="tree-left" style="height:calc(100vh - 152px);">
        <elUnitTree @checkFun="mysearch" :dataList="virtualDeviceList"></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%;">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <span style="width: 60px;">应用类型</span>
              <elUnitTree2 @checkFun="mysearch"></elUnitTree2>
              <div class="input-small mr-20">
                <span>日期：</span>
                <el-date-picker @change="mysearch" value-format="timestamp" v-model="datetimeValue" type="daterange"
                  :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期"></el-date-picker>
              </div>
              <div class="input-small myinput">
                <span>间隔(分钟)：</span>
                <el-select v-model="timeInterval" placeholder="请选择" class="eSel" @change="mysearch">
                  <el-option v-for="item in times" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
              <el-button type="primary" @click="mysearch" plain class="search-btn">查询</el-button>
              <!-- <el-button @click="exportButton" type="primary" class="search-btn">导出</el-button> historyValue-->
            </div>
          </el-scrollbar>
        </div>
        <div class="mychart" :style="{ width: '100%', height: `${heights}px` }">
          <vchart style="height: 100%;" ref="vchart"></vchart>
        </div>
        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>

      <downloadTable ref="downloadTable"></downloadTable>
    </div>
  </div>
</template>

<style>
.eSel input {
  width: 80px;
}
</style>
<script type="text/javascript">
import downloadTable from "@/components/module/downloadTable/downloadTable.vue";
import vchart from "@/components/module/chart/vchart.vue";
import elUnitTree from "@/components/module/newTree/elDeviceTree.vue";
import elUnitTree2 from "@/components/module/newTree/elUnitTree2.vue";
import request from "@/api/http.js";
export default {
  components: {
    vchart,
    elUnitTree,
    elUnitTree2,
    downloadTable,
  },
  props: [],
  data() {
    return {
      coloms: [],
      dataList: [],
      shouMenu: false,
      shouMenu2: false,
      all: [], //总no数据
      flag: false,
      nowPage: [],
      deviceNos: [],
      dataed: [],
      dataed_un: [],
      defaultProps: "",
      loading: false,
      heights: Math.round(document.getElementById("app").clientHeight * 0.76),
      apptypeValue: [],
      // nowDevice: {}, //当前选中设备列表
      nowApptypeGroups: [], //当前选中的应用类型组
      bgDate: new Date(new Date().formatByDate()),
      endDate: new Date(),
      checkVariablename: [], //需要显示的变量名称
      timeInterval: 30, //时间间隔,单位是分钟
      options: {
        title: {
          text: "数据曲线",
          left: "left",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#1a1a1a" },
        },
        toolbox: {
          show: true,
          showTitle: true,
          top: "-5",
          right: "50",
          feature: {
            magicType: {
              type: ["line", "bar", "stack", "tiled"],
              title: {
                line: "切换为折线图",
                bar: "切换为柱状图",
                stack: "切换为堆叠",
                tiled: "切换为平铺",
              },
            },
            saveAsImage: { show: true, title: "下载图片" },
          },
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: { animation: false },
        },
        xAxis: {
          type: "time",
          splitLine: { show: false, lineStyle: { width: 0.5, type: "solid" } },
        },
        yAxis: {
          lineStyle: { show: false, width: 1, type: "solid" },
          min: 168.63,
        },
        dataZoom: [
          { type: "slider", show: true, start: 0, end: 50, handleSize: 8 },
          { type: "inside", start: 0, end: 100 },
        ],
        grid: { left: "5%", right: "2%", bottom: "100", containLabel: true },
        legend: {
          data: [
            { name: "A相电流", icon: "roundRect" },
            { name: "B相电流", icon: "roundRect" },
            { name: "C相电流", icon: "roundRect" },
            { name: "A相有功功率", icon: "roundRect" },
            { name: "B相有功功率", icon: "roundRect" },
            { name: "C相有功功率", icon: "roundRect" },
            { name: "总有功功率", icon: "roundRect" },
            { name: "A相电流", icon: "roundRect" },
            { name: "B相电流", icon: "roundRect" },
            { name: "C相电流", icon: "roundRect" },
            { name: "A相有功功率", icon: "roundRect" },
            { name: "B相有功功率", icon: "roundRect" },
            { name: "C相有功功率", icon: "roundRect" },
            { name: "总有功功率", icon: "roundRect" },
          ],
          type: "scroll",
          bottom: "60px",
          tooltip: { show: true },
          selected: {
            A相电流: true,
            B相电流: true,
            C相电流: true,
            A相有功功率: true,
            B相有功功率: true,
            C相有功功率: true,
            总有功功率: true,
          },
        },
        series: [
          {
            name: "A相电流",
            fromName: "设备机电总进线数显表.A相电流",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712678400000, Math.floor(Math.random() * 10), "A"],
              [1712680200000, Math.floor(Math.random() * 10), "A"],
              [1712682000000, Math.floor(Math.random() * 10), "A"],
              [1712683800000, Math.floor(Math.random() * 10), "A"],
              [1712685600000, Math.floor(Math.random() * 10), "A"],
              [1712687400000, Math.floor(Math.random() * 10), "A"],
              [1712689200000, Math.floor(Math.random() * 10), "A"],
              [1712691000000, Math.floor(Math.random() * 10), "A"],
              [1712692800000, Math.floor(Math.random() * 10), "A"],
              [1712694600000, Math.floor(Math.random() * 10), "A"],
              [1712696400000, Math.floor(Math.random() * 10), "A"],
              [1712698200000, Math.floor(Math.random() * 10), "A"],
              [1712700000000, Math.floor(Math.random() * 10), "A"],
              [1712701800000, Math.floor(Math.random() * 10), "A"],
              [1712703600000, Math.floor(Math.random() * 10), "A"],
              [1712705400000, Math.floor(Math.random() * 10), "A"],
              [1712707200000, Math.floor(Math.random() * 10), "A"],
              [1712709000000, Math.floor(Math.random() * 10), "A"],
              [1712710800000, Math.floor(Math.random() * 10), "A"],
              [1712712600000, Math.floor(Math.random() * 10), "A"],
              [1712714400000, Math.floor(Math.random() * 10), "A"],
              [1712716200000, Math.floor(Math.random() * 10), "A"],
              [1712718000000, Math.floor(Math.random() * 10), "A"],
              [1712719800000, Math.floor(Math.random() * 10), "A"],
              [1712721600000, Math.floor(Math.random() * 10), "A"],
              [1712723400000, Math.floor(Math.random() * 10), "A"],
              [1712725200000, Math.floor(Math.random() * 10), "A"],
              [1712727000000, Math.floor(Math.random() * 10), "A"],
              [1712728800000, Math.floor(Math.random() * 10), "A"],
              [1712730600000, Math.floor(Math.random() * 10), "A"],
              [1712732400000, Math.floor(Math.random() * 10), "A"],
              [1712734200000, Math.floor(Math.random() * 10), "A"],
              [1712736000000, Math.floor(Math.random() * 10), "A"],
              [1712737800000, Math.floor(Math.random() * 10), "A"],
              [1712739600000, Math.floor(Math.random() * 10), "A"],
              [1712741400000, Math.floor(Math.random() * 10), "A"],
              [1712743200000, Math.floor(Math.random() * 10), "A"],
              [1712745000000, Math.floor(Math.random() * 10), "A"],
              [1712746800000, Math.floor(Math.random() * 10), "A"],
              [1712748600000, Math.floor(Math.random() * 10), "A"],
              [1712750400000, Math.floor(Math.random() * 10), "A"],
              [1712752200000, Math.floor(Math.random() * 10), "A"],
              [1712754000000, Math.floor(Math.random() * 10), "A"],
              [1712755800000, Math.floor(Math.random() * 10), "A"],
              [1712757600000, Math.floor(Math.random() * 10), "A"],
              [1712759400000, Math.floor(Math.random() * 10), "A"],
              [1712761200000, Math.floor(Math.random() * 10), "A"],
              [1712763000000, Math.floor(Math.random() * 10), "A"],
            ],
          },
          {
            name: "B相电流",
            fromName: "设备机电总进线数显表.B相电流",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712678400000, Math.floor(Math.random() * 20), "A"],
              [1712680200000, Math.floor(Math.random() * 20), "A"],
              [1712682000000, Math.floor(Math.random() * 20), "A"],
              [1712683800000, Math.floor(Math.random() * 20), "A"],
              [1712685600000, Math.floor(Math.random() * 20), "A"],
              [1712687400000, Math.floor(Math.random() * 20), "A"],
              [1712689200000, Math.floor(Math.random() * 20), "A"],
              [1712691000000, Math.floor(Math.random() * 20), "A"],
              [1712692800000, Math.floor(Math.random() * 20), "A"],
              [1712694600000, Math.floor(Math.random() * 20), "A"],
              [1712696400000, Math.floor(Math.random() * 20), "A"],
              [1712698200000, Math.floor(Math.random() * 20), "A"],
              [1712700000000, Math.floor(Math.random() * 20), "A"],
              [1712701800000, Math.floor(Math.random() * 20), "A"],
              [1712703600000, Math.floor(Math.random() * 20), "A"],
              [1712705400000, Math.floor(Math.random() * 20), "A"],
              [1712707200000, Math.floor(Math.random() * 20), "A"],
              [1712709000000, Math.floor(Math.random() * 20), "A"],
              [1712710800000, Math.floor(Math.random() * 20), "A"],
              [1712712600000, Math.floor(Math.random() * 20), "A"],
              [1712714400000, Math.floor(Math.random() * 20), "A"],
              [1712716200000, Math.floor(Math.random() * 20), "A"],
              [1712718000000, Math.floor(Math.random() * 20), "A"],
              [1712719800000, Math.floor(Math.random() * 20), "A"],
              [1712721600000, Math.floor(Math.random() * 20), "A"],
              [1712723400000, Math.floor(Math.random() * 20), "A"],
              [1712725200000, Math.floor(Math.random() * 20), "A"],
              [1712727000000, Math.floor(Math.random() * 20), "A"],
              [1712728800000, Math.floor(Math.random() * 20), "A"],
              [1712730600000, Math.floor(Math.random() * 20), "A"],
              [1712732400000, Math.floor(Math.random() * 20), "A"],
              [1712734200000, Math.floor(Math.random() * 20), "A"],
              [1712736000000, Math.floor(Math.random() * 20), "A"],
              [1712737800000, Math.floor(Math.random() * 20), "A"],
              [1712739600000, Math.floor(Math.random() * 20), "A"],
              [1712741400000, Math.floor(Math.random() * 20), "A"],
              [1712743200000, Math.floor(Math.random() * 20), "A"],
              [1712745000000, Math.floor(Math.random() * 20), "A"],
              [1712746800000, Math.floor(Math.random() * 20), "A"],
              [1712748600000, Math.floor(Math.random() * 20), "A"],
              [1712750400000, Math.floor(Math.random() * 20), "A"],
              [1712752200000, Math.floor(Math.random() * 20), "A"],
              [1712754000000, Math.floor(Math.random() * 20), "A"],
              [1712755800000, Math.floor(Math.random() * 20), "A"],
              [1712757600000, Math.floor(Math.random() * 20), "A"],
              [1712759400000, Math.floor(Math.random() * 20), "A"],
              [1712761200000, Math.floor(Math.random() * 20), "A"],
              [1712763000000, Math.floor(Math.random() * 20), "A"],
            ],
          },
          {
            name: "C相电流",
            fromName: "设备机电总进线数显表.C相电流",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712678400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712680200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712682000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712683800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712685600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712687400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712689200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712691000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712692800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712694600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712696400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712698200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712700000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712701800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712703600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712705400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712707200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712709000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712710800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712712600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712714400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712716200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712718000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712719800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712721600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712723400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712725200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712727000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712728800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712730600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712732400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712734200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712736000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712737800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712739600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712741400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712743200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712745000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712746800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712748600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712750400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712752200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712754000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712755800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712757600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712759400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712761200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712763000000, Math.floor(Math.random() * 10) + 200, "A"],
            ],
          },
          {
            name: "A相有功功率",
            fromName: "设备机电总进线数显表.A相有功功率",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712678400000, 173, "kW"],
              [1712680200000, 173, "kW"],
              [1712682000000, 173, "kW"],
              [1712683800000, 173, "kW"],
              [1712685600000, 173, "kW"],
              [1712687400000, 173, "kW"],
              [1712689200000, 173, "kW"],
              [1712691000000, 173, "kW"],
              [1712692800000, 173, "kW"],
              [1712694600000, 173, "kW"],
              [1712696400000, 173, "kW"],
              [1712698200000, 173, "kW"],
              [1712700000000, 173, "kW"],
              [1712701800000, 173, "kW"],
              [1712703600000, 173, "kW"],
              [1712705400000, 173, "kW"],
              [1712707200000, 173, "kW"],
              [1712709000000, 173, "kW"],
              [1712710800000, 173, "kW"],
              [1712712600000, 173, "kW"],
              [1712714400000, 173, "kW"],
              [1712716200000, 173, "kW"],
              [1712718000000, 173, "kW"],
              [1712719800000, 173, "kW"],
              [1712721600000, 173, "kW"],
              [1712723400000, 173, "kW"],
              [1712725200000, 173, "kW"],
              [1712727000000, 173, "kW"],
              [1712728800000, 173, "kW"],
              [1712730600000, 173, "kW"],
              [1712732400000, 173, "kW"],
              [1712734200000, 173, "kW"],
              [1712736000000, 173, "kW"],
              [1712737800000, 173, "kW"],
              [1712739600000, 173, "kW"],
              [1712741400000, 173, "kW"],
              [1712743200000, 173, "kW"],
              [1712745000000, 173, "kW"],
              [1712746800000, 173, "kW"],
              [1712748600000, 173, "kW"],
              [1712750400000, 173, "kW"],
              [1712752200000, 173, "kW"],
              [1712754000000, 173, "kW"],
              [1712755800000, 173, "kW"],
              [1712757600000, 173, "kW"],
              [1712759400000, 173, "kW"],
              [1712761200000, 173, "kW"],
              [1712763000000, 173, "kW"],
            ],
          },
          {
            name: "B相有功功率",
            fromName: "设备机电总进线数显表.B相有功功率",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712678400000, 168.63, "kW"],
              [1712680200000, 168.63, "kW"],
              [1712682000000, 168.63, "kW"],
              [1712683800000, 168.63, "kW"],
              [1712685600000, 168.63, "kW"],
              [1712687400000, 168.63, "kW"],
              [1712689200000, 168.63, "kW"],
              [1712691000000, 168.63, "kW"],
              [1712692800000, 168.63, "kW"],
              [1712694600000, 168.63, "kW"],
              [1712696400000, 168.63, "kW"],
              [1712698200000, 168.63, "kW"],
              [1712700000000, 168.63, "kW"],
              [1712701800000, 168.63, "kW"],
              [1712703600000, 168.63, "kW"],
              [1712705400000, 168.63, "kW"],
              [1712707200000, 168.63, "kW"],
              [1712709000000, 168.63, "kW"],
              [1712710800000, 168.63, "kW"],
              [1712712600000, 168.63, "kW"],
              [1712714400000, 168.63, "kW"],
              [1712716200000, 168.63, "kW"],
              [1712718000000, 168.63, "kW"],
              [1712719800000, 168.63, "kW"],
              [1712721600000, 168.63, "kW"],
              [1712723400000, 168.63, "kW"],
              [1712725200000, 168.63, "kW"],
              [1712727000000, 168.63, "kW"],
              [1712728800000, 168.63, "kW"],
              [1712730600000, 168.63, "kW"],
              [1712732400000, 168.63, "kW"],
              [1712734200000, 168.63, "kW"],
              [1712736000000, 168.63, "kW"],
              [1712737800000, 168.63, "kW"],
              [1712739600000, 168.63, "kW"],
              [1712741400000, 168.63, "kW"],
              [1712743200000, 168.63, "kW"],
              [1712745000000, 168.63, "kW"],
              [1712746800000, 168.63, "kW"],
              [1712748600000, 168.63, "kW"],
              [1712750400000, 168.63, "kW"],
              [1712752200000, 168.63, "kW"],
              [1712754000000, 168.63, "kW"],
              [1712755800000, 168.63, "kW"],
              [1712757600000, 168.63, "kW"],
              [1712759400000, 168.63, "kW"],
              [1712761200000, 168.63, "kW"],
              [1712763000000, 168.63, "kW"],
            ],
          },
          {
            name: "C相有功功率",
            fromName: "设备机电总进线数显表.C相有功功率",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712678400000, 171.54, "kW"],
              [1712680200000, 171.54, "kW"],
              [1712682000000, 171.54, "kW"],
              [1712683800000, 171.54, "kW"],
              [1712685600000, 171.54, "kW"],
              [1712687400000, 171.54, "kW"],
              [1712689200000, 171.54, "kW"],
              [1712691000000, 171.54, "kW"],
              [1712692800000, 171.54, "kW"],
              [1712694600000, 171.54, "kW"],
              [1712696400000, 171.54, "kW"],
              [1712698200000, 171.54, "kW"],
              [1712700000000, 171.54, "kW"],
              [1712701800000, 171.54, "kW"],
              [1712703600000, 171.54, "kW"],
              [1712705400000, 171.54, "kW"],
              [1712707200000, 171.54, "kW"],
              [1712709000000, 171.54, "kW"],
              [1712710800000, 171.54, "kW"],
              [1712712600000, 171.54, "kW"],
              [1712714400000, 171.54, "kW"],
              [1712716200000, 171.54, "kW"],
              [1712718000000, 171.54, "kW"],
              [1712719800000, 171.54, "kW"],
              [1712721600000, 171.54, "kW"],
              [1712723400000, 171.54, "kW"],
              [1712725200000, 171.54, "kW"],
              [1712727000000, 171.54, "kW"],
              [1712728800000, 171.54, "kW"],
              [1712730600000, 171.54, "kW"],
              [1712732400000, 171.54, "kW"],
              [1712734200000, 171.54, "kW"],
              [1712736000000, 171.54, "kW"],
              [1712737800000, 171.54, "kW"],
              [1712739600000, 171.54, "kW"],
              [1712741400000, 171.54, "kW"],
              [1712743200000, 171.54, "kW"],
              [1712745000000, 171.54, "kW"],
              [1712746800000, 171.54, "kW"],
              [1712748600000, 171.54, "kW"],
              [1712750400000, 171.54, "kW"],
              [1712752200000, 171.54, "kW"],
              [1712754000000, 171.54, "kW"],
              [1712755800000, 171.54, "kW"],
              [1712757600000, 171.54, "kW"],
              [1712759400000, 171.54, "kW"],
              [1712761200000, 171.54, "kW"],
              [1712763000000, 171.54, "kW"],
            ],
          },
          {
            name: "总有功功率",
            fromName: "设备机电总进线数显表.总有功功率",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712678400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712680200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712682000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712683800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712685600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712687400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712689200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712691000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712692800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712694600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712696400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712698200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712700000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712701800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712703600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712705400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712707200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712709000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712710800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712712600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712714400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712716200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712718000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712719800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712721600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712723400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712725200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712727000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712728800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712730600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712732400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712734200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712736000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712737800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712739600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712741400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712743200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712745000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712746800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712748600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712750400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712752200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712754000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712755800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712757600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712759400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712761200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712763000000, Math.floor(Math.random() * 10) + 200, "无"],
            ],
          },
          {
            name: "A相电流",
            fromName: "设备机电总进线数显表.A相电流",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712764800000, Math.floor(Math.random() * 10), "A"],
              [1712766600000, Math.floor(Math.random() * 10), "A"],
              [1712768400000, Math.floor(Math.random() * 10), "A"],
              [1712770200000, Math.floor(Math.random() * 10), "A"],
              [1712772000000, Math.floor(Math.random() * 10), "A"],
              [1712773800000, Math.floor(Math.random() * 10), "A"],
              [1712775600000, Math.floor(Math.random() * 10), "A"],
              [1712777400000, Math.floor(Math.random() * 10), "A"],
              [1712779200000, Math.floor(Math.random() * 10), "A"],
              [1712781000000, Math.floor(Math.random() * 10), "A"],
              [1712782800000, Math.floor(Math.random() * 10), "A"],
              [1712784600000, Math.floor(Math.random() * 10), "A"],
              [1712786400000, Math.floor(Math.random() * 10), "A"],
              [1712788200000, Math.floor(Math.random() * 10), "A"],
              [1712790000000, Math.floor(Math.random() * 10), "A"],
              [1712791800000, Math.floor(Math.random() * 10), "A"],
              [1712793600000, Math.floor(Math.random() * 10), "A"],
              [1712795400000, Math.floor(Math.random() * 10), "A"],
              [1712797200000, Math.floor(Math.random() * 10), "A"],
              [1712799000000, Math.floor(Math.random() * 10), "A"],
              [1712800800000, Math.floor(Math.random() * 10), "A"],
              [1712802600000, Math.floor(Math.random() * 10), "A"],
              [1712804400000, Math.floor(Math.random() * 10), "A"],
              [1712806200000, Math.floor(Math.random() * 10), "A"],
              [1712808000000, Math.floor(Math.random() * 10), "A"],
              [1712809800000, Math.floor(Math.random() * 10), "A"],
              [1712811600000, Math.floor(Math.random() * 10), "A"],
              [1712813400000, Math.floor(Math.random() * 10), "A"],
              [1712815200000, Math.floor(Math.random() * 10), "A"],
              [1712817000000, Math.floor(Math.random() * 10), "A"],
              [1712818800000, Math.floor(Math.random() * 10), "A"],
              [1712820600000, Math.floor(Math.random() * 10), "A"],
              [1712822400000, Math.floor(Math.random() * 10), "A"],
              [1712824200000, "", "A"],
              [1712826000000, Math.floor(Math.random() * 10), "A"],
              [1712827800000, Math.floor(Math.random() * 10), "A"],
              [1712829600000, Math.floor(Math.random() * 10), "A"],
              [1712831400000, Math.floor(Math.random() * 10), "A"],
              [1712833200000, Math.floor(Math.random() * 10), "A"],
              [1712835000000, Math.floor(Math.random() * 10), "A"],
              [1712836800000, Math.floor(Math.random() * 10), "A"],
              [1712838600000, Math.floor(Math.random() * 10), "A"],
              [1712840400000, Math.floor(Math.random() * 10), "A"],
              [1712842200000, Math.floor(Math.random() * 10), "A"],
              [1712844000000, Math.floor(Math.random() * 10), "A"],
              [1712845800000, Math.floor(Math.random() * 10), "A"],
              [1712847600000, Math.floor(Math.random() * 10), "A"],
              [1712849400000, Math.floor(Math.random() * 10), "A"],
            ],
          },
          {
            name: "B相电流",
            fromName: "设备机电总进线数显表.B相电流",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712764800000, Math.floor(Math.random() * 20), "A"],
              [1712766600000, Math.floor(Math.random() * 20), "A"],
              [1712768400000, Math.floor(Math.random() * 20), "A"],
              [1712770200000, Math.floor(Math.random() * 20), "A"],
              [1712772000000, Math.floor(Math.random() * 20), "A"],
              [1712773800000, Math.floor(Math.random() * 20), "A"],
              [1712775600000, Math.floor(Math.random() * 20), "A"],
              [1712777400000, Math.floor(Math.random() * 20), "A"],
              [1712779200000, Math.floor(Math.random() * 20), "A"],
              [1712781000000, Math.floor(Math.random() * 20), "A"],
              [1712782800000, Math.floor(Math.random() * 20), "A"],
              [1712784600000, Math.floor(Math.random() * 20), "A"],
              [1712786400000, Math.floor(Math.random() * 20), "A"],
              [1712788200000, Math.floor(Math.random() * 20), "A"],
              [1712790000000, Math.floor(Math.random() * 20), "A"],
              [1712791800000, Math.floor(Math.random() * 20), "A"],
              [1712793600000, Math.floor(Math.random() * 20), "A"],
              [1712795400000, Math.floor(Math.random() * 20), "A"],
              [1712797200000, Math.floor(Math.random() * 20), "A"],
              [1712799000000, Math.floor(Math.random() * 20), "A"],
              [1712800800000, Math.floor(Math.random() * 20), "A"],
              [1712802600000, Math.floor(Math.random() * 20), "A"],
              [1712804400000, Math.floor(Math.random() * 20), "A"],
              [1712806200000, Math.floor(Math.random() * 20), "A"],
              [1712808000000, Math.floor(Math.random() * 20), "A"],
              [1712809800000, Math.floor(Math.random() * 20), "A"],
              [1712811600000, Math.floor(Math.random() * 20), "A"],
              [1712813400000, Math.floor(Math.random() * 20), "A"],
              [1712815200000, Math.floor(Math.random() * 20), "A"],
              [1712817000000, Math.floor(Math.random() * 20), "A"],
              [1712818800000, Math.floor(Math.random() * 20), "A"],
              [1712820600000, Math.floor(Math.random() * 20), "A"],
              [1712822400000, Math.floor(Math.random() * 20), "A"],
              [1712824200000, "", "A"],
              [1712826000000, Math.floor(Math.random() * 20), "A"],
              [1712827800000, Math.floor(Math.random() * 20), "A"],
              [1712829600000, Math.floor(Math.random() * 20), "A"],
              [1712831400000, Math.floor(Math.random() * 20), "A"],
              [1712833200000, Math.floor(Math.random() * 20), "A"],
              [1712835000000, Math.floor(Math.random() * 20), "A"],
              [1712836800000, Math.floor(Math.random() * 20), "A"],
              [1712838600000, Math.floor(Math.random() * 20), "A"],
              [1712840400000, Math.floor(Math.random() * 20), "A"],
              [1712842200000, Math.floor(Math.random() * 20), "A"],
              [1712844000000, Math.floor(Math.random() * 20), "A"],
              [1712845800000, Math.floor(Math.random() * 20), "A"],
              [1712847600000, Math.floor(Math.random() * 20), "A"],
              [1712849400000, Math.floor(Math.random() * 20), "A"],
            ],
          },
          {
            name: "C相电流",
            fromName: "设备机电总进线数显表.C相电流",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712764800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712766600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712768400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712770200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712772000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712773800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712775600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712777400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712779200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712781000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712782800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712784600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712786400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712788200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712790000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712791800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712793600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712795400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712797200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712799000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712800800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712802600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712804400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712806200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712808000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712809800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712811600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712813400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712815200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712817000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712818800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712820600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712822400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712824200000, "", "A"],
              [1712826000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712827800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712829600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712831400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712833200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712835000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712836800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712838600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712840400000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712842200000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712844000000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712845800000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712847600000, Math.floor(Math.random() * 10) + 200, "A"],
              [1712849400000, Math.floor(Math.random() * 10) + 200, "A"],
            ],
          },
          {
            name: "A相有功功率",
            fromName: "设备机电总进线数显表.A相有功功率",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712764800000, 173, "kW"],
              [1712766600000, 173, "kW"],
              [1712768400000, 173, "kW"],
              [1712770200000, 173, "kW"],
              [1712772000000, 173, "kW"],
              [1712773800000, 173, "kW"],
              [1712775600000, 173, "kW"],
              [1712777400000, 173, "kW"],
              [1712779200000, 173, "kW"],
              [1712781000000, 173, "kW"],
              [1712782800000, 173, "kW"],
              [1712784600000, 173, "kW"],
              [1712786400000, 173, "kW"],
              [1712788200000, 173, "kW"],
              [1712790000000, 173, "kW"],
              [1712791800000, 173, "kW"],
              [1712793600000, 173, "kW"],
              [1712795400000, 173, "kW"],
              [1712797200000, 173, "kW"],
              [1712799000000, 173, "kW"],
              [1712800800000, 173, "kW"],
              [1712802600000, 173, "kW"],
              [1712804400000, 173, "kW"],
              [1712806200000, 173, "kW"],
              [1712808000000, 173, "kW"],
              [1712809800000, 173, "kW"],
              [1712811600000, 173, "kW"],
              [1712813400000, 173, "kW"],
              [1712815200000, 173, "kW"],
              [1712817000000, 173, "kW"],
              [1712818800000, 173, "kW"],
              [1712820600000, 173, "kW"],
              [1712822400000, 173, "kW"],
              [1712824200000, "", "kW"],
              [1712826000000, 173, "kW"],
              [1712827800000, 173, "kW"],
              [1712829600000, 173, "kW"],
              [1712831400000, 173, "kW"],
              [1712833200000, 173, "kW"],
              [1712835000000, 173, "kW"],
              [1712836800000, 173, "kW"],
              [1712838600000, 173, "kW"],
              [1712840400000, 173, "kW"],
              [1712842200000, 173, "kW"],
              [1712844000000, 173, "kW"],
              [1712845800000, 173, "kW"],
              [1712847600000, 173, "kW"],
              [1712849400000, 173, "kW"],
            ],
          },
          {
            name: "B相有功功率",
            fromName: "设备机电总进线数显表.B相有功功率",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712764800000, 168.63, "kW"],
              [1712766600000, 168.63, "kW"],
              [1712768400000, 168.63, "kW"],
              [1712770200000, 168.63, "kW"],
              [1712772000000, 168.63, "kW"],
              [1712773800000, 168.63, "kW"],
              [1712775600000, 168.63, "kW"],
              [1712777400000, 168.63, "kW"],
              [1712779200000, 168.63, "kW"],
              [1712781000000, 168.63, "kW"],
              [1712782800000, 168.63, "kW"],
              [1712784600000, 168.63, "kW"],
              [1712786400000, 168.63, "kW"],
              [1712788200000, 168.63, "kW"],
              [1712790000000, 168.63, "kW"],
              [1712791800000, 168.63, "kW"],
              [1712793600000, 168.63, "kW"],
              [1712795400000, 168.63, "kW"],
              [1712797200000, 168.63, "kW"],
              [1712799000000, 168.63, "kW"],
              [1712800800000, 168.63, "kW"],
              [1712802600000, 168.63, "kW"],
              [1712804400000, 168.63, "kW"],
              [1712806200000, 168.63, "kW"],
              [1712808000000, 168.63, "kW"],
              [1712809800000, 168.63, "kW"],
              [1712811600000, 168.63, "kW"],
              [1712813400000, 168.63, "kW"],
              [1712815200000, 168.63, "kW"],
              [1712817000000, 168.63, "kW"],
              [1712818800000, 168.63, "kW"],
              [1712820600000, 168.63, "kW"],
              [1712822400000, 168.63, "kW"],
              [1712824200000, "", "kW"],
              [1712826000000, 168.63, "kW"],
              [1712827800000, 168.63, "kW"],
              [1712829600000, 168.63, "kW"],
              [1712831400000, 168.63, "kW"],
              [1712833200000, 168.63, "kW"],
              [1712835000000, 168.63, "kW"],
              [1712836800000, 168.63, "kW"],
              [1712838600000, 168.63, "kW"],
              [1712840400000, 168.63, "kW"],
              [1712842200000, 168.63, "kW"],
              [1712844000000, 168.63, "kW"],
              [1712845800000, 168.63, "kW"],
              [1712847600000, 168.63, "kW"],
              [1712849400000, 168.63, "kW"],
            ],
          },
          {
            name: "C相有功功率",
            fromName: "设备机电总进线数显表.C相有功功率",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712764800000, 171.54, "kW"],
              [1712766600000, 171.54, "kW"],
              [1712768400000, 171.54, "kW"],
              [1712770200000, 171.54, "kW"],
              [1712772000000, 171.54, "kW"],
              [1712773800000, 171.54, "kW"],
              [1712775600000, 171.54, "kW"],
              [1712777400000, 171.54, "kW"],
              [1712779200000, 171.54, "kW"],
              [1712781000000, 171.54, "kW"],
              [1712782800000, 171.54, "kW"],
              [1712784600000, 171.54, "kW"],
              [1712786400000, 171.54, "kW"],
              [1712788200000, 171.54, "kW"],
              [1712790000000, 171.54, "kW"],
              [1712791800000, 171.54, "kW"],
              [1712793600000, 171.54, "kW"],
              [1712795400000, 171.54, "kW"],
              [1712797200000, 171.54, "kW"],
              [1712799000000, 171.54, "kW"],
              [1712800800000, 171.54, "kW"],
              [1712802600000, 171.54, "kW"],
              [1712804400000, 171.54, "kW"],
              [1712806200000, 171.54, "kW"],
              [1712808000000, 171.54, "kW"],
              [1712809800000, 171.54, "kW"],
              [1712811600000, 171.54, "kW"],
              [1712813400000, 171.54, "kW"],
              [1712815200000, 171.54, "kW"],
              [1712817000000, 171.54, "kW"],
              [1712818800000, 171.54, "kW"],
              [1712820600000, 171.54, "kW"],
              [1712822400000, 171.54, "kW"],
              [1712824200000, "", "kW"],
              [1712826000000, 171.54, "kW"],
              [1712827800000, 171.54, "kW"],
              [1712829600000, 171.54, "kW"],
              [1712831400000, 171.54, "kW"],
              [1712833200000, 171.54, "kW"],
              [1712835000000, 171.54, "kW"],
              [1712836800000, 171.54, "kW"],
              [1712838600000, 171.54, "kW"],
              [1712840400000, 171.54, "kW"],
              [1712842200000, 171.54, "kW"],
              [1712844000000, 171.54, "kW"],
              [1712845800000, 171.54, "kW"],
              [1712847600000, 171.54, "kW"],
              [1712849400000, 171.54, "kW"],
            ],
          },
          {
            name: "总有功功率",
            fromName: "设备机电总进线数显表.总有功功率",
            type: "line",
            smooth: false,
            markPoint: {
              data: [
                { name: "最大值", formatter: "{b}:{c}", type: "max" },
                { name: "最小值", formatter: "{b}:{c}", type: "min" },
              ],
            },
            symbol: "emptyCircle",
            sampling: "average",
            data: [
              [1712764800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712766600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712768400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712770200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712772000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712773800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712775600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712777400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712779200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712781000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712782800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712784600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712786400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712788200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712790000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712791800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712793600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712795400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712797200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712799000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712800800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712802600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712804400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712806200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712808000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712809800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712811600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712813400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712815200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712817000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712818800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712820600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712822400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712824200000, "", "无"],
              [1712826000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712827800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712829600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712831400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712833200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712835000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712836800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712838600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712840400000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712842200000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712844000000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712845800000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712847600000, Math.floor(Math.random() * 10) + 200, "无"],
              [1712849400000, Math.floor(Math.random() * 10) + 200, "无"],
            ],
          },
        ],
      },
      from2name: {},
      count: 0,
      datetimeValue: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date(new Date().toLocaleDateString());
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date(new Date().toLocaleDateString());
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      times: [5, 15, 30, 60],
      arr15: [],
      arr30: [],
      arr60: [],
      list2: [],
      nowDevice: [],
    };
  },
  mounted() {
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    var timestamp = now.getTime();
    this.datetimeValue = [timestamp, new Date().getTime()];
    console.log(this.options, 111);

    this.$refs.vchart.setData(this.options, true);

    this.colomsFn();
  },

  computed: {
    nowSelectAppTypeGroupIds() {
      return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(
        this.apptypeGroups
      );
    },
    // nowDevice () {
    //   console.log("this.$store.deviceStore.state.nowVirtualDevice",this.$store.deviceStore.state.nowVirtualDevice);
    //   return this.$store.deviceStore.state.nowVirtualDevice
    // },
    getReadDeviceTree() {
      return [this.deviceStore.getters.getReadDeviceTree];
    },
    variableStore() {
      return this.$store.variableStore;
    },
    virtualDeviceList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      return isempty(data) ? [] : [deviceList(data)];
    },
    deviceStore() {
      return this.$store.deviceStore;
    },
    deviceTree() {
      return [this.deviceStore.getters.getReadDeviceTree];
    },
    variableTree() {
      if (isempty(this.nowDevice)) {
        return [];
      }
      return this.variableStore.getters.getVariableTree(this.nowDevice.no);
    },
    apptypeGroups() {
      //所有已选中的设备所具有的变量类型组
      var list = [];
      var apptypeGroupIds = [];
      this.variableTree.forEach((apptypeGroup) => {
        if (!apptypeGroupIds.includes(apptypeGroup.id)) {
          apptypeGroupIds.push(apptypeGroup.id);
          list.push(apptypeGroup);
        }
      });
      //排序
      list.sort((a, b) => {
        return a.serialnum - b.serialnum;
      });

      let idList = [];
      list.forEach((item) => {
        idList.push(item.id);
      });
      this.apptypeValue = idList;
      return list;
    },

    nowVariableNames() {
      //当前应该显示的变量fromname列表
      var ag = this.nowApptypeGroups.map((item) => {
        return item.id;
      });
      var v1 = this.variableTree.filter((item) => {
        return ag.includes(item.id);
      });
      if (isempty(v1)) {
        return [];
      }
      var v2 = [];
      v1.forEach((item) => {
        item.next.forEach((i) => {
          this.from2name[i.fromName] = i.name + "(" + item.unit + ")";
          v2.push(i.fromName); //name !=  fromName
        });
      });
      return v2;
    },
    timeObject() {
      //时间列表,根据开始结束时间和时间间隔计算
      //var start = this.bgDate.getTime()
      //var end = this.endDate.getTime() + 24 * 60 * 60 * 1000
      var start = this.datetimeValue[0];
      var end = this.datetimeValue[1] + 24 * 60 * 60 * 1000;
      var obj = {};
      while (start < end) {
        obj[start] = 0;
        start += this.timeInterval * 60 * 1000;
      }
      return obj;
    },
    nowSeries() {
      if (isempty(this.variableTree)) {
        return [];
      }
      var fromnameList = [];
      this.variableTree.forEach((item) => {
        item.next.forEach((i) => {
          fromnameList.push(i.fromName); //fromName
        });
      });
      var list = [];
      fromnameList.forEach((item) => {
        var name = this.from2name[item] ? this.from2name[item] : item;
        name = name.subByFirstChar(".");
        list.push({
          name: name,
          fromName: item,
          type: "line",
          smooth: true,
          markPoint: {
            data: [
              {
                name: "最大值",
                formatter: "{b}:{c}",
                type: "max",
              },
              {
                name: "最小值",
                formatter: "{b}:{c}",
                type: "min",
              },
            ],
          },
          symbol: "emptyCircle",
          symbolSize: 20,
          sampling: "average",
          data: [],
        });
      });
      return list;
    },
  },

  methods: {
    mysearch2() {
      this.$router.push("/historyValue");
    },
    // 时间戳转换
    // 转换时间戳
    date_format_fn(value) {
      if (!value) {
        return "";
      }
      let date = new Date(value);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";

      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let strDate = Y + M + D + h + m + s;
      return `'${strDate}'`;
    },
    exportButton() {
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();

      const tHeader = [
        "查询时间",
        this.date_format_fn(this.datetimeValue[0]) +
        "-" +
        this.date_format_fn(this.datetimeValue[1]),
        "间隔(分钟)",
        this.timeInterval,
      ];
      this.$refs.downloadTable.export2Excel(
        tHeader,
        this.dataList,
        year + "-" + month + "-" + day + "-历史列表",
        "#region-cost"
      );
    },
    searchHistory(v) {
      if (
        this.datetimeValue[1] - this.datetimeValue[0] >=
        180 * 24 * 60 * 60 * 1000
      ) {
        this.$message({
          message: "时间跨度请勿超过180天",
          type: "warning",
        });
        return;
      }
      var params = {
        startTime: this.datetimeValue[0],
        endTime: this.datetimeValue[1],
        variableNames: v.join(","),
      };
      this.loading = true;
      request({
        url: "/real/findHistoryByVariableName",
        method: "get",
        params,
      }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listFilter(res.data);
        }
      });
    },
    // 过滤数据
    listFilter(v) {
      var d = []; //数据
      var coloms = []; //键
      var str = "";
      v.map((a) => {
        a.energyHistory.map((b, i) => {
          b.issueValues.map((c) => {
            var colomData = {};
            for (const key in c) {
              if (key.includes("value") && key != "valueUnit") {
                str = key.substring(5, 7) + " : " + key.substring(7, 9);
                colomData[str] = c[key] == -1.1111 ? "" : c[key];
              } else {
                colomData[key] = c[key] == -1.1111 ? "" : c[key];
              }
              if (!d.length) {
                if (key.includes("value") && key != "valueUnit") {
                  str = key.substring(5, 7) + " : " + key.substring(7, 9);
                  // coloms.push(str)
                }
              }
            }
            colomData.dateTimer = b.selectTime;
            d.push(colomData);
          });
          // d[i].dateTimer=b.selectTime
        });
      });
      if (this.timeInterval == 5) {
        this.coloms = JSON.parse(JSON.stringify(this.colomsCopy));
      } else if (this.timeInterval == 15) {
        this.coloms = this.arr15;
      } else if (this.timeInterval == 30) {
        this.coloms = this.arr30;
      } else if (this.timeInterval == 60) {
        this.coloms = this.arr60;
      }
      this.dataList = d;

      this.loading = false;
      var series = [];
      var legend = [];
      var selectLegend = {};
      var dd = []; //所有值
      d.map((a, count) => {
        var data = [];
        this.coloms.map((v) => {
          var nowDate = new Date(
            a.dateTimer + " " + v.replace(/\s/g, "")
          ).getTime();
          data.push([nowDate, a[v], a.valueUnit]);
          if (a[v]) {
            dd.push(a[v]);
          }
        });

        var item = a.name.subByFirstChar(".");
        series.push({
          name: item,
          fromName: a.name,
          type: "line",
          smooth: true,
          markPoint: {
            data: [
              {
                name: "最大值",
                formatter: "{b}:{c}",
                type: "max",
              },
              {
                name: "最小值",
                formatter: "{b}:{c}",
                type: "min",
              },
            ],
          },
          smooth: false,
          symbol: "emptyCircle",
          sampling: "average",
          data,
        });

        legend.push({
          name: item,
          icon: "roundRect",
        });
        selectLegend[item] = count < 6 ? true : false;
      });
      for (const key in selectLegend) {
        selectLegend[key] = true;
      }
      console.log(selectLegend, "selectLegend");
      this.options.legend.data = legend;
      this.options.yAxis.min = Math.min(...dd); //设置最小值
      this.options.legend.selected = selectLegend;
      this.options.series = series;
      this.$refs.vchart.setData(this.options, true);
    },

    // 过滤键方法
    colomsFn() {
      this.colomsCopy = [
        "00 : 00",
        "00 : 05",
        "00 : 10",
        "00 : 15",
        "00 : 20",
        "00 : 25",
        "00 : 30",
        "00 : 35",
        "00 : 40",
        "00 : 45",
        "00 : 50",
        "00 : 55",
        "01 : 00",
        "01 : 05",
        "01 : 10",
        "01 : 15",
        "01 : 20",
        "01 : 25",
        "01 : 30",
        "01 : 35",
        "01 : 40",
        "01 : 45",
        "01 : 50",
        "01 : 55",
        "02 : 00",
        "02 : 05",
        "02 : 10",
        "02 : 15",
        "02 : 20",
        "02 : 25",
        "02 : 30",
        "02 : 35",
        "02 : 40",
        "02 : 45",
        "02 : 50",
        "02 : 55",
        "03 : 00",
        "03 : 05",
        "03 : 10",
        "03 : 15",
        "03 : 20",
        "03 : 25",
        "03 : 30",
        "03 : 35",
        "03 : 40",
        "03 : 45",
        "03 : 50",
        "03 : 55",
        "04 : 00",
        "04 : 05",
        "04 : 10",
        "04 : 15",
        "04 : 20",
        "04 : 25",
        "04 : 30",
        "04 : 35",
        "04 : 40",
        "04 : 45",
        "04 : 50",
        "04 : 55",
        "05 : 00",
        "05 : 05",
        "05 : 10",
        "05 : 15",
        "05 : 20",
        "05 : 25",
        "05 : 30",
        "05 : 35",
        "05 : 40",
        "05 : 45",
        "05 : 50",
        "05 : 55",
        "06 : 00",
        "06 : 05",
        "06 : 10",
        "06 : 15",
        "06 : 20",
        "06 : 25",
        "06 : 30",
        "06 : 35",
        "06 : 40",
        "06 : 45",
        "06 : 50",
        "06 : 55",
        "07 : 00",
        "07 : 05",
        "07 : 10",
        "07 : 15",
        "07 : 20",
        "07 : 25",
        "07 : 30",
        "07 : 35",
        "07 : 40",
        "07 : 45",
        "07 : 50",
        "07 : 55",
        "08 : 00",
        "08 : 05",
        "08 : 10",
        "08 : 15",
        "08 : 20",
        "08 : 25",
        "08 : 30",
        "08 : 35",
        "08 : 40",
        "08 : 45",
        "08 : 50",
        "08 : 55",
        "09 : 00",
        "09 : 05",
        "09 : 10",
        "09 : 15",
        "09 : 20",
        "09 : 25",
        "09 : 30",
        "09 : 35",
        "09 : 40",
        "09 : 45",
        "09 : 50",
        "09 : 55",
        "10 : 00",
        "10 : 05",
        "10 : 10",
        "10 : 15",
        "10 : 20",
        "10 : 25",
        "10 : 30",
        "10 : 35",
        "10 : 40",
        "10 : 45",
        "10 : 50",
        "10 : 55",
        "11 : 00",
        "11 : 05",
        "11 : 10",
        "11 : 15",
        "11 : 20",
        "11 : 25",
        "11 : 30",
        "11 : 35",
        "11 : 40",
        "11 : 45",
        "11 : 50",
        "11 : 55",
        "12 : 00",
        "12 : 05",
        "12 : 10",
        "12 : 15",
        "12 : 20",
        "12 : 25",
        "12 : 30",
        "12 : 35",
        "12 : 40",
        "12 : 45",
        "12 : 50",
        "12 : 55",
        "13 : 00",
        "13 : 05",
        "13 : 10",
        "13 : 15",
        "13 : 20",
        "13 : 25",
        "13 : 30",
        "13 : 35",
        "13 : 40",
        "13 : 45",
        "13 : 50",
        "13 : 55",
        "14 : 00",
        "14 : 05",
        "14 : 10",
        "14 : 15",
        "14 : 20",
        "14 : 25",
        "14 : 30",
        "14 : 35",
        "14 : 40",
        "14 : 45",
        "14 : 50",
        "14 : 55",
        "15 : 00",
        "15 : 05",
        "15 : 10",
        "15 : 15",
        "15 : 20",
        "15 : 25",
        "15 : 30",
        "15 : 35",
        "15 : 40",
        "15 : 45",
        "15 : 50",
        "15 : 55",
        "16 : 00",
        "16 : 05",
        "16 : 10",
        "16 : 15",
        "16 : 20",
        "16 : 25",
        "16 : 30",
        "16 : 35",
        "16 : 40",
        "16 : 45",
        "16 : 50",
        "16 : 55",
        "17 : 00",
        "17 : 05",
        "17 : 10",
        "17 : 15",
        "17 : 20",
        "17 : 25",
        "17 : 30",
        "17 : 35",
        "17 : 40",
        "17 : 45",
        "17 : 50",
        "17 : 55",
        "18 : 00",
        "18 : 05",
        "18 : 10",
        "18 : 15",
        "18 : 20",
        "18 : 25",
        "18 : 30",
        "18 : 35",
        "18 : 40",
        "18 : 45",
        "18 : 50",
        "18 : 55",
        "19 : 00",
        "19 : 05",
        "19 : 10",
        "19 : 15",
        "19 : 20",
        "19 : 25",
        "19 : 30",
        "19 : 35",
        "19 : 40",
        "19 : 45",
        "19 : 50",
        "19 : 55",
        "20 : 00",
        "20 : 05",
        "20 : 10",
        "20 : 15",
        "20 : 20",
        "20 : 25",
        "20 : 30",
        "20 : 35",
        "20 : 40",
        "20 : 45",
        "20 : 50",
        "20 : 55",
        "21 : 00",
        "21 : 05",
        "21 : 10",
        "21 : 15",
        "21 : 20",
        "21 : 25",
        "21 : 30",
        "21 : 35",
        "21 : 40",
        "21 : 45",
        "21 : 50",
        "21 : 55",
        "22 : 00",
        "22 : 05",
        "22 : 10",
        "22 : 15",
        "22 : 20",
        "22 : 25",
        "22 : 30",
        "22 : 35",
        "22 : 40",
        "22 : 45",
        "22 : 50",
        "22 : 55",
        "23 : 00",
        "23 : 05",
        "23 : 10",
        "23 : 15",
        "23 : 20",
        "23 : 25",
        "23 : 30",
        "23 : 35",
        "23 : 40",
        "23 : 45",
        "23 : 50",
        "23 : 55",
      ];
      var str = "";
      this.arr15 = [];
      this.arr30 = [];
      this.arr60 = [];
      //  this.coloms=JSON.parse(JSON.stringify(this.colomsCopy));
      this.colomsCopy.forEach((item) => {
        str = item.substring(5, 7);
        if (str == "00" || str == "15" || str == "30" || str == "45") {
          this.arr15.push(item);
        }
        if (str == "00" || str == "30") {
          this.arr30.push(item);
        }
        if (str == "00") {
          this.arr60.push(item);
        }
      });
      // this.timeInterval_fn(this.timeInterval)
      // this.coloms = this.newcoloms
    },
    getMath(index) {
      if (!index) {
        index = 10;
      }
      var min = index - index / 10; // 确保min是整数
      var max = index + index / 10; // 确保max是整数
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    mysearch() {
      this.flag = false;
      var en = [];
      this.options.series.map((v) => {
        v.data.map((a) => {
          a[1] = this.getMath(a[1]);
        });
      });

      this.$refs.vchart.setData(this.options, true);
    },
    checkFun2(v) {
      if (v == 1) {
        this.updateEnableStatus(this.copyNowVirtualDeviceList);
        this.shouMenu2 = false;
      } else {
        this.defaultProps = v;
      }
    },

    checkFun(val) {
      this.nowDevice = val[0];
      var d = [];
      this.nowVirtualDevice = val;
      this.nowVirtualDevice.map((v) => {
        //通过FormData构造函数创建一个空对象
        var data = new FormData();
        //可以通过append()方法来追加数据
        data.append("deviceNo", v.no);
        //通过get方法对值进行读取
        request({
          url: "/variable/getVariableTree.do",
          method: "post",
          data,
        }).then((res) => {
          d = [...d, ...res.data];
          var a = [];
          d.map((v) => {
            a.push({
              id: v.id,
              name: v.name,
              value: v.entityName,
            });
          });
          if (a.length) {
            this.list2 = a;
            if (this.apptypeValue.length == 0) {
              this.apptypeValue = [a[0].id];
            }
          }
        });
      });

      var d = [];
      this.dataed = [];
      this.deviceNos = [];
      val.map((v) => {
        this.deviceNos.push(v.no);
        d.push(v.no);
      });
      if (val.length) {
        this.copyNowVirtualDeviceList = d;
        this.updateEnableStatus(this.copyNowVirtualDeviceList);
      }
    },
    // 应用类型->修改应用类型参与查询状态
    updateEnableStatus(data) {
      var params = {
        deviceNos: data.join(","),
      };
      // /variable/findAppTypeByDeviceNo
      request({
        url: "/variable/findAppTypeByDeviceNo",
        method: "get",
        params,
      }).then((res) => {
        // console.log(res,'修改应用类型参与查询状态');
        if (res.code == 200) {
          this.dataed = res.data.used;
          this.all = [];
          this.defaultProps = [];
          this.dataed.map((v) => {
            if (v.children) {
              v.children.map((a) => {
                this.all.push(a.no);
                if (a.enable === 0) {
                  this.defaultProps.push(a.no);
                }
              });
            }
          });
          this.dataed_un = res.data.unused;
        }
      });
    },
    timeInterval_fn() { },
    selectAll() {
      //全选 先判断是否有选中的，有选中就清空
      if (this.apptypeValue.length == 1) {
        this.nowApptypeGroup = this.apptypeGroups;
        let idList = [];
        this.apptypeGroups.forEach((item) => {
          idList.push(item.id);
        });
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", idList);
        this.apptypeValue = idList;
      } else {
        this.nowApptypeGroup = [];
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", []);
        this.apptypeValue = [];
      }
    },
    autoSelectMethod(item, index) {
      if (this.nowDevice != undefined) {
        return this.nowDevice.id == item.id && this.nowDevice.type == item.type;
      } else {
        return item.type == "virtualDevice";
      }
    },
    checkDevice(data) {
      // this.nowDevice = data
      this.$store.deviceStore.commit("setNowVirtualDevice", data);
    },
    setSeries(timeObject) {
      var nl = [];
      var fromnameList = this.nowVariableNames;
      var legend = [];
      var selectLegend = {};
      var count = 0;
      //根据当前选中类型组和时间间隔过滤数据然后设置一下
      for (var i = 0, len = this.nowSeries.length; i < len; i++) {
        var item = this.nowSeries[i];
        if (!fromnameList.includes(item.fromName)) {
          continue;
        }
        var newname = this.from2name[item.fromName]
          ? this.from2name[item.fromName]
          : item.name;
        var nameRes = newname.subByFirstChar(".");
        var nitem = {
          name: nameRes,
          fromName: item.fromName,
          type: item.type,
          smooth: item.smooth,
          symbol: item.symbol,
          sampling: item.sampling,
          markPoint: {
            data: [
              {
                name: "最大值",
                formatter: "{b}:{c}",
                type: "max",
              },
              {
                name: "最小值",
                formatter: "{b}:{c}",
                type: "min",
              },
            ],
          },
          smooth: false,
          data: [],
        };
        var list = [];
        for (var j = 0, lens = item.data.length; j < lens; j++) {
          if (timeObject.hasOwnProperty(item.data[j][0])) {
            var temp = item.data[j];
            if (isNaN(parseFloat(temp)) || isnull(parseFloat(temp))) {
              temp = undefined;
            }
            list.push(temp);
          }
        }
        nitem.data = list;

        nl.push(nitem);
        legend.push({
          name: nameRes,
          icon: "roundRect",
        });
        selectLegend[nameRes] = count++ < 6 ? true : false;
      }
      var chart = this.$refs.vchart;
      var options = chart.getOptions();
      options.series = nl;
      options.legend.data = legend;
      options.legend.selected = selectLegend;
      //如果数量太多就控制一下缩放
      if (
        Object.keys(this.timeObject).length > 144 &&
        options.dataZoom[0].end - options.dataZoom[0].start > 20
      ) {
        options.dataZoom[0].start = 0;
        options.dataZoom[0].end = 10;
        options.dataZoom[1].start = 0;
        options.dataZoom[1].end = 10;
      } else {
        options.dataZoom[0].start = 0;
        options.dataZoom[0].end = 100;
        options.dataZoom[1].start = 0;
        options.dataZoom[1].end = 100;
      }
      options.title.text = this.nowDevice.name;
      // console.log(JSON.stringify(options));
      // console.log("历史",options);

      chart.setData(options, true);
    },
    deviceSelect(item) {
      this.nowDevice = item;
    },
    selectBgDate(date) {
      this.bgDate = date;
    },
    selectEndDate(date) {
      this.endDate = date;
    },
    showpicker(no) {
      if (no == 1) {
        this.$refs.datepicker.show();
      } else {
        this.$refs.datepicker2.show();
      }
    },
    selectInterval(interval) {
      this.timeInterval = interval;
    },
  },
};
</script>

<style scoped lang="scss">
.eSel {
  width: 80px;
  overflow: hidden;
}

.right-table {
  /deep/.el-scrollbar {
    overflow: inherit;
  }

  /deep/.el-scrollbar__wrap {
    overflow-y: hidden;
  }

  .search-input-btn {
    overflow: inherit;
  }

  .unitMenu {
    overflow: hidden;

    /deep/.el-scrollbar__wrap {
      overflow-y: inherit;
    }
  }
}

.historyCurve {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    /deep/.el-date-editor .el-range-separator {
      line-height: 26px;
    }

    /deep/.el-date-editor .el-range__icon {
      line-height: 23px;
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button+.el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }
    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 100%;
      padding: 2px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;
    }
  }
}
</style>
<style scoped>
.block {
  width: 20px;
  height: 20px;
  background-color: #d9d9d9;
  cursor: pointer;
  margin-left: 10px;
}

.unitMenu {
  /* max-width: 4rem; */
  height: 4rem;
  top: 7px;
  padding-top: 32px;
  position: absolute;
  z-index: 99999;
}

.unitMenu .elUnitTreeBody {
  width: 2.4rem;
}

.unitMenu .readDeviceTreeBody {
  border-width: 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
}

.cropper-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ul {
  padding: 0 15px;
}

.ul .li {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.ul .li .r {
  color: #378cd4;
  cursor: pointer;
}

.btns {
  width: 300px;
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #d7d7d7;
  margin: 0 15px;
}

.color-span {
  display: inline-block;
  width: 15px;
  height: 15px;
  transform: translate(5px, 2px);
  color: #1a1a1a;
}

.user-arrow {
  width: 20px;
  height: 20px;
}

.tongyi-img {
  width: 20px;
  height: 20px;
}

.arrow-active {
  transform: rotateZ(180deg);
}

.topMenu {
  height: 0.5rem;
  overflow-y: hidden;
  /* overflow: hidden; */
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.nowUnit-name {
  margin-left: 0.2rem;
  width: 100px;
  height: 30px;
  border: 1px solid #ccc;
  text-align: left;
  line-height: 30px;
  padding: 0px 12px;
  /* margin-left: 5px; */
  border-radius: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nowUnit-name span {
  color: #666666;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.nowUnit-name img {
  width: 18px;
  height: 18px;
  transition: 0.5s;
}

.nowUnit-active {
  border: 1px solid #409eff;
}

.nowUnit-active1 {
  border: 1px solid #fff;
}

.nowUnit-active img {
  transform: rotateZ(180deg);
}

.nowUnit-active1 img {
  transform: rotateZ(180deg);
}

/* 需要转化 */
.tags-view-container {
  height: 34px;
  width: calc(100% - 2rem);
  position: absolute;
  top: 48px;
  left: 200px;
  /* margin-left: 200px; */
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  -webkit-box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
  z-index: 999;
}

.tags-view-container .content {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
}

.sidebar-logo {
  width: 32px;
  height: 32px;
  vertical-align: middle;
}

.sidebar-title {
  display: inline-block;
  margin: 0;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
  vertical-align: middle;
  margin-left: 10px;
}

/* 需要转化结束 */

.userName {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #1a1a1a;
}

.webTitle {
  height: 0.5rem;
  width: auto;
  text-align: center;
  line-height: 0.5rem;
  font-size: 21px;
  font-weight: bold;
  width: 500px;
  color: #212529;
}

.leftPart {
  /* width: calc(50% - 150px); */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* background-color: #2b2f3a; */
  /* background-color: #fff; */
}

.leftPart-logo {
  width: 2rem;
  height: 0.5rem;
  box-sizing: border-box;
  padding: 9px;
  /* background-color: #304156; */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.35s;
  flex-shrink: 0;
}

.leftPart-logo-active {
  width: 0.8rem;
}

.logo {
  max-width: 185px;
  max-height: 40px;
}

.rightPart {
  /* width: calc(50% - 50px); */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.leftPartImg {
  height: 48px;
  display: flex;
  align-items: center;
  width: 50px;
  /*border-bottom: 2px solid #116af0;*/
}

.rightPart .user {
  /* width: auto; */
  margin-left: 10px;
  max-width: 2rem;
  min-width: 0.2rem;
  /* height: .2rem; */
}

.rightPart .userSelect {
  cursor: pointer;
  width: auto;
  max-width: 2rem;
  min-width: 0.08rem;
  height: 0.06rem;
  margin-right: 20px;
  margin-top: 11px;
}

.unitSelect {
  /* min-width: 1rem; */
  height: 100%;
  /*border-bottom: 2px solid #cce1ff;*/
  height: 48px;
}

.unitSelect>div>input {
  width: 150px;
  background: rgba(0, 0, 0, 0);
  border: 0;
  /* border-left: 1px #49649c solid; */
  border: 1px solid #dcdfe6;
  border-radius: 0;
  padding: 5px 10px;
  height: 20px;
  line-height: 20px;
  outline: none;
  margin: 0 10px;
  color: white;
}

.userMenu {
  padding-top: 0.5rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9999;
}

.area-tree {
  position: absolute;
  max-width: 2.5rem;
  height: 4rem;
  /* margin-left: 4rem; */
  /* top: 0; */
  top: 0;
  /* right: 0px; */
  margin-left: 19px;
  padding-top: 0.5rem;
  z-index: 99999;
  width: 77%;
}

.area-tree .elUnitTreeBody {
  width: 2.4rem;
}

.area-tree .readDeviceTreeBody {
  border-width: 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
}

.menuItem {
  height: 33px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.05rem 0.1rem;
  width: auto;
  cursor: pointer;
  background: white;
  border-left: solid 0.01rem #babec2;
  border-right: solid 0.01rem #babec2;
  border-bottom: solid 0.01rem #babec2;
}

.menuItem:last-child {
  border-radius: 0 0 0.05rem 0.05rem;
}

.menuItem>span {
  text-align: left;
  width: 0.7rem;
  padding-left: 0.1rem;
}

.tool-class {
  width: 50%;
}

.nowTimeBox {
  /*border-bottom: 2px solid #cce1ff;*/
  height: 48px;
  /* color: white; */
  color: #666666;
  line-height: 50px;
  margin-right: 10px;
}

.msgDialog {
  position: absolute;
  width: 360px;
  height: 440px;
  background: white;
  z-index: 5;
  top: 50px;
  right: 20px;
  border-radius: 5px;
  border: 1px silver solid;
  z-index: 110;
}

.msgDialog>p {
  padding-right: 20px;
  line-height: 40px;
  text-align: right;
  border-bottom: 1px silver solid;
  color: #0092dc;
}

/* 修改默认列表样式 */

.msgDialog>>>ul.list-body {
  border-radius: 0;
}

.msgDialog>>>ul.list-body>li {
  padding: 0;
  border-bottom: none;
  background: none;
  cursor: default;
}

.msgOperate {
  overflow: hidden;
  padding: 0 24px;
  border-bottom: solid 1px #cccccc;
}

.msgOperate>button {
  height: 20px;
  box-sizing: border-box;
  margin: 8px 12px;
  color: #0f87db;
  padding: 0 8px;
  background: #ffffff;
  outline: none;
  border: solid 1px #ffffff;
  border-radius: 10px;
  cursor: pointer;
}

.msgOperate>.isFilter {
  border-color: #0f87db;
}

.isFilter {
  color: #0f87db;
  background: none;
}

.msgOperate>span {
  float: right;
  line-height: 36px;
}

.filterDialog {
  position: absolute;
  height: 300px;
  width: 250px;
  background: white;
  top: 50px;
  z-index: 100;
}

.unitName {
  max-width: 140px;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.existMsg {
  position: absolute;
  left: 5px;
  top: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: red;
  color: #ffffff;
  font-size: 0.12rem;
  text-align: center;
  line-height: 20px;
  transform: scale(0.6);
}

.unreadMsgInfo {
  padding: 10px 24px 0 24px;
}

.unreadHead {
  margin-bottom: 6px;
  overflow: hidden;
}

.msgTypeName {
  float: left;
  background: #0582da;
  line-height: 18px;
  padding: 0 8px;
  border-radius: 8px;
  font-size: 0.12rem;
  color: #ffffff;
}

.msgMarkBtn {
  float: right;
  height: 18px;
  box-sizing: border-box;
  border: solid 1px #0f87db;
  border-radius: 8px;
  font-size: 0.12rem;
  padding: 0 8px;
  line-height: 16px;
  color: #0f87db;
  background: #ffffff;
  cursor: pointer;
}

.msgTimeText {
  float: right;
  line-height: 18px;
  font-size: 0.12rem;
  color: #0f87db;
}

.msgIntro {
  font-size: 0.12rem;
  text-indent: 2em;
  padding-bottom: 10px;
  border-bottom: solid 1px #cccccc;
  white-space: normal;
}

.unReadMsg {
  background-color: #e3ebf1;
}
</style>
